var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainbox"},[_c('div',{staticClass:"detail_right"},[_c('div',{staticClass:"detail_right_til"},[_vm._v(_vm._s(_vm.schooltem.schoolName))]),_c('div',{staticClass:"question_list",domProps:{"innerHTML":_vm._s(_vm.schooltem.introductory)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }